import styled from 'styled-components'

export const Card = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  borderRadius: theme.border.radius['8'],
  boxShadow: theme.shadow.sm,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['20'],
  height: '100%',
  overflow: 'hidden',
  padding: theme.space['20'],
  position: 'relative',
  width: '100%',
}))

export const LoaderOverlay = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
}))
